"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class RasterUtil
 */
var RasterUtil = /** @class */ (function () {
    function RasterUtil() {
    }
    /**
     * Creates a default ColorMapEntry with the the required properties.
     */
    RasterUtil.generateColorMapEntry = function () {
        return {
            color: '#000'
        };
    };
    return RasterUtil;
}());
exports.default = RasterUtil;
//# sourceMappingURL=RasterUtil.js.map